<template>
  <div>
    <p class="xPadding titleModal">
      {{ $t(`treatmentProgram.step0.title`) }}
    </p>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VAutocomplete
          v-model="data.siteProduct"
          :label="$t('treatmentProgram.step0.productName')"
          :items="displayedProducts"
          :loading="loading"
          :rules="{required: true}"
          itemValue="id"
          outlined
          clearable
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

export default {
    name: 'ProgramInfo',
    components: {
        VAutocomplete,
    },
    props: {
        siteProduct: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            data: {},
            products: [],
            treatments: [],
        };
    },
    computed: {
        ...mapGetters([
            'site',
            'network',
        ]),
        productsInUsed() {
            return this.treatments.reduce((productsInUsed, product) => ({
                ...productsInUsed,
                [product?.siteProduct?.id]: product?.siteProduct?.id,
            }), {});
        },
        isProductInUsed() {
            return productId => productId in this.productsInUsed;
        },
        displayedProducts() {
            return this.products.map(product => ({
                ...product,
                disabled: this.isProductInUsed(product.id),
            }));
        },
    },
    watch: {
        siteProduct: {
            handler() {
                this.data.siteProduct = this.siteProduct?.id;
            },
            immediate: true,

        },
    },
    async created() {
        await this.getProducts();
        await this.getTreatments();
    },
    methods: {
        async getProducts() {
            this.loading = true;
            const { data } = await this.$rq.getSiteProducts(this.site.id, { pagination: false });
            this.products = data.products;
            this.loading = false;
        },
        async getTreatments() {
            const { data } = await this.$rq.getSteamTreatmentPrograms(this.network.id);
            this.treatments = data;
        },
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};
</script>
  <style lang="scss" scoped>
  .xPadding{
    padding: 0 6rem;
  }
  @media screen and (max-width: 600px) {
     .xPadding{
        padding: 0;
      }
  }
  </style>
